iScreenWizard.factory('Profiel', function ($q, Ajax) {

    var data = {};

    data.get = function() {
        return $q(function (resolve, reject) {
            Ajax.get('profile').then(function (response) {
                var profile = response.data;
                resolve(profile);
            }, reject);
        });
    };

    return data;
});